import { render, staticRenderFns } from "./chronicle.vue?vue&type=template&id=2a463dee&scoped=true&"
import script from "./chronicle.vue?vue&type=script&lang=js&"
export * from "./chronicle.vue?vue&type=script&lang=js&"
import style0 from "./chronicle.vue?vue&type=style&index=0&id=2a463dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a463dee",
  null
  
)

component.options.__file = "chronicle.vue"
export default component.exports